import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class LicenseRequest extends BaseModel {
  static modelName = 'LicenseRequest'
  static instanceDefaults () {
    return {
      companyName: '',
      organizationNumber: '',
      companyType: '',
      otherCompanyType: null,
      norskEiendomMember: 'no',
      contactName: '',
      contactEmail: '',
      contactPhone: '',
      billingContact: '',
      billingAddress: '',
      ehfId: null,
      poNumber: null,
      acceptTerms: false,
      acceptBilling: false,
      selectedPlan: null,
      status: 'pending',
      recipientOrganizationId: null,
      notes: null,
      convertedAt: null,
      convertedByUserId: null,
      convertedOrganizationId: null,
      convertedUserId: null,
    }
  }
}

const servicePath = 'license-requests'
const servicePlugin = makeServicePlugin({
  Model: LicenseRequest,
  service: feathersClient.service(servicePath),
  servicePath,
})

export default servicePlugin
